// Shared data for the "Built on BuildersLab" showcase — used by the homepage
// section and the Portfolio page.

export const LIVE_DEMOS = [
  {
    slug: 'pulseboard',
    title: 'PulseBoard',
    category: 'webapp',
    categoryLabel: 'Web App',
    tagline: 'Realtime analytics for modern teams',
    description:
      'A full SaaS analytics dashboard with live KPI counters, a realtime traffic chart, an interactive task board and searchable campaign tables — the kind of internal tool teams usually wait weeks for.',
    prompt: 'Build me a dark analytics dashboard for my SaaS with charts, tasks and campaign tracking',
    features: ['Animated KPI counters', 'Canvas traffic chart', 'Interactive task list', 'Live table search'],
    buildTime: '38s',
    accent: '#6366f1',
    thumb: '/images/showcase/pulseboard.jpg',
    url: '/showcase/pulseboard.html',
  },
  {
    slug: 'neonbreaker',
    title: 'Neon Breaker',
    category: 'games',
    categoryLabel: 'Game',
    tagline: 'A synthwave arcade classic — fully playable',
    description:
      'A complete browser game: paddle physics with spin, multi-hit bricks, particle explosions, levels that speed up and a proper game-over loop. Playable with mouse, keyboard or touch — all in one HTML file.',
    prompt: 'Make me a playable neon retro arcade brick-breaker game with levels, lives and particle effects',
    features: ['60fps canvas engine', 'Mouse, keys & touch controls', 'Levels + score + lives', 'Particle explosions'],
    buildTime: '52s',
    accent: '#b967ff',
    thumb: '/images/showcase/neonbreaker.jpg',
    url: '/showcase/neonbreaker.html',
  },
  {
    slug: 'aurelia',
    title: 'AURELIA',
    category: 'shopping',
    categoryLabel: 'Shopping',
    tagline: 'Considered essentials, minimalist storefront',
    description:
      'An elegant fashion e-commerce experience with an editorial hero, product grid and a fully working cart drawer — add items, change quantities and watch the totals update in real time.',
    prompt: 'Create a minimal luxury fashion store with a working shopping cart and elegant serif typography',
    features: ['Working cart drawer', 'Quantity + live totals', 'Editorial typography', 'Marquee promo strip'],
    buildTime: '44s',
    accent: '#9a6b41',
    thumb: '/images/showcase/aurelia.jpg',
    url: '/showcase/aurelia.html',
  },
  {
    slug: 'meridian',
    title: 'Meridian',
    category: 'banking',
    categoryLabel: 'Banking',
    tagline: 'Banking, without the queue',
    description:
      'A neobank dashboard with balance privacy toggle, filterable transactions, an animated spending donut, savings goals and a send-money flow with validation and instant confirmation toasts.',
    prompt: 'Design a digital bank dashboard with transactions, spending breakdown and a transfer flow',
    features: ['Send-money modal', 'Filterable transactions', 'Animated spending donut', 'Savings goal tracker'],
    buildTime: '47s',
    accent: '#a3e635',
    thumb: '/images/showcase/meridian.jpg',
    url: '/showcase/meridian.html',
  },
  {
    slug: 'amara',
    title: 'Amara Okafor®',
    category: 'portfolio',
    categoryLabel: 'Portfolio',
    tagline: 'Brand designer portfolio with teeth',
    description:
      'A bold editorial portfolio: oversized typography, a cursor-following project preview, marquee skill strip, stats and a working contact form. Confident enough to win clients on its own.',
    prompt: 'Build a bold Swiss-style portfolio for a brand designer with huge type and hover previews',
    features: ['Cursor-follow previews', 'Editorial type system', 'Working contact form', 'Marquee + stats'],
    buildTime: '35s',
    accent: '#e8490f',
    thumb: '/images/showcase/amara.jpg',
    url: '/showcase/amara.html',
  },
  {
    slug: 'nebula',
    title: 'Nebula',
    category: 'web3',
    categoryLabel: 'Web3',
    tagline: 'Trade the open galaxy',
    description:
      'A glassmorphic DeFi dashboard with a live-updating portfolio chart, price ticker, top pools and a working token swap widget with rate quotes, flip direction and wallet-connect flow.',
    prompt: 'Create a futuristic DeFi trading dashboard with a token swap widget and live portfolio chart',
    features: ['Working swap quotes', 'Live-updating chart', 'Price ticker marquee', 'Wallet connect flow'],
    buildTime: '49s',
    accent: '#8b5cf6',
    thumb: '/images/showcase/nebula.jpg',
    url: '/showcase/nebula.html',
  },
];

// Earlier client work & concepts (static screenshots, no live demo).
export const ARCHIVE_PROJECTS = [
  { title: 'Andre Digitalz', categoryLabel: 'Landing Page', image: '/images/2bd57e9f7_andre-digitalz-2.jpg' },
  { title: 'GamePoint', categoryLabel: 'Web App', image: '/images/e5139a6ee_gamepoint.png' },
  { title: 'Liquid Sort', categoryLabel: 'iOS/Android', image: '/images/b4fb8a206_liquidsort.png' },
  { title: 'MetaCraft', categoryLabel: 'Web App', image: '/images/3e53f35e2_metacraft.jpg' },
  { title: 'i-glare Optics', categoryLabel: 'E-Commerce', image: '/images/3ea4583da_iglareoptics.png' },
  { title: 'Nika Shoes', categoryLabel: 'E-Commerce', image: '/images/af93c851b_nika.png' },
  { title: 'Find You', categoryLabel: 'Landing Page', image: '/images/f3524f4e9_find-you.png' },
  { title: 'Item Zero', categoryLabel: 'Landing Page', image: '/images/b3a3cca2d_item-zero.png' },
  { title: 'Jessie Chuks', categoryLabel: 'Portfolio', image: '/images/bcad995f1_jessiechuks-2.png' },
  { title: 'Kindred Dating', categoryLabel: 'iOS/Android', image: '/images/c01bd0185_kindred-dating-app.png' },
  { title: 'KSD & Co', categoryLabel: 'Corporate', image: '/images/db3c9ca0c_ksd-and-co.jpg' },
  { title: 'Music in a Box', categoryLabel: 'iOS/Android', image: '/images/18a7c20f7_music-in-a-box.png' },
  { title: 'The Travel Agent', categoryLabel: 'Landing Page', image: '/images/90237e37e_the-travel-agent.jpg' },
];
